import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle
} from '@ui/dialog.tsx';
import type { LogicTypeStepWorkspaceReadModel } from '@r/api/generated/client.schemas.ts';
import { UpdateStepForm } from './update-step-form.tsx';

interface UpdateStepDialogProps {
  step: LogicTypeStepWorkspaceReadModel | null;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess: () => void;
}

/** Coque modale autour de {@link UpdateStepForm}. */
export const UpdateStepDialog: FC<UpdateStepDialogProps> = ({
  step,
  isOpen,
  onOpenChange,
  onSuccess
}) => {
  const { t } = useTranslation();

  const handleSuccess = () => {
    onOpenChange(false);
    onSuccess();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="p-10 !rounded-3xl">
        <DialogHeader>
          <DialogTitle className="text-2xl">
            {t('admin.settings.steps.update.dialog.title')}
          </DialogTitle>
          <DialogDescription>
            {t('admin.settings.steps.update.dialog.description')}
          </DialogDescription>
        </DialogHeader>

        {isOpen && step && (
          <UpdateStepForm key={step.id ?? step.name} step={step} onSuccess={handleSuccess} />
        )}
      </DialogContent>
    </Dialog>
  );
};
